import {
    AppIdentifiers,
    ITopicHeaders,
    MessageBroker,
    PostLoginActionNameEnum,
    UiChannel,
} from '@sparkware/uc-sdk-core';
import Container from 'typedi';
import { TypeUtils } from '../../../../Modules/Utils/TypeUtils';
import { StorageItemEnum } from '../../../models/enums/storage-enums';
import { LocalSimpleStoreService } from '../../storage/implementations/simple-store';
import DialogType from '../../ui/enums/DialogType';
import { IPostLoginActionsState } from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import { IFeatureAvailability } from '../../feature/feature-availability/feature-availability-interface';
import { FeatureAvailabilityToken } from '../../../injection-tokens';
import { ABTestFeatures } from '../../action-handler/enums/consts';

const HEADER: ITopicHeaders = { publisher: 'ShowOnboardingPostLoginAction' };

export class ShowOnboardingPostLoginAction extends PostLoginActionBase {
    private _localSimpleStoreService: LocalSimpleStoreService;
    private _uiChannel: UiChannel;
    private readonly _featureAvailability: IFeatureAvailability;

    constructor(state: IPostLoginActionsState) {
        super(PostLoginActionNameEnum.ShowOnboarding, 'ShowOnboardingPostLoginAction', state);

        this._localSimpleStoreService = Container.get(LocalSimpleStoreService);
        this._uiChannel = MessageBroker.getInstance().ui;
        this._featureAvailability = Container.get(FeatureAvailabilityToken);
    }

    protected override canExecute = async (): Promise<boolean> => {
        const isFFEnabled = await this._featureAvailability.FeatureIsEnabled(
            AppIdentifiers.CRMPromotions,
            ABTestFeatures.CRM_PROMOTIONS,
        );
        const isOnboardingProcessed = TypeUtils.toBoolean(
            this._localSimpleStoreService.get(StorageItemEnum.IsOnboardingProcessed),
        );

        const canExecute = isFFEnabled && !isOnboardingProcessed;

        return Promise.resolve(canExecute);
    };

    protected override doAction = async (): Promise<boolean> => {
        await this.delay(10000);
        this.clearOptions();

        this._localSimpleStoreService.set(StorageItemEnum.IsOnboardingProcessed, true);

        const dialogOptions = {
            onClose: this.completeAction,
        };

        this._uiChannel.topics.DialogShow.publish(HEADER, {
            dialogType: DialogType.ShowOnboarding,
            options: dialogOptions,
        });

        return false;
    };

    private delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
}
